export default "__VITE_ASSET__D$cfV338__"